module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAABHNCSVQICAgIfAhkiAAAATxJREFUKJGNUs15wjAMfQodwgkXRpAxd5xN2knibMImce5APUJ6AU+BenBMfmj7VRd/kp6eniQTRmM+WOBxBJGFUBvC2WNmzAcLkiZ8XuocK1Ji34CkAwAItSBpWBtZFXYALGvT5Tg9E0L1vBvzvhn5+5xPrzgQ2fB5qcF8WLAtpGojrI2kkZKfiVmbrgAeR4j4n4oB+LUiAAjh2kKoLZIsci9dx27rwong7Dcx3galSqiyckptv2K8DWmBOEHoI8bbMC2VrCorm3EbAIjx3itV7kB4V2V1AuBDuNaZSJWVz7EnTpW7F6nr5bE2XR5hwu0b1kboKSkbkYOIm/l2/jFmpFIsWIksAL/w/7rEP2TLq+yEe/uFdTIRB0LH2ngIten/i4NQvZnjxrPtYrz3U+zeK7XtQbAgWABDvsQ3/U6t6318YykAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/SsendSex.png
// module id = 5sz6
// module chunks = 1